import "./ContactSection.scss";

type Contact = {
  name: string;
  phoneLabel: string;
  phoneHref: string;
  role: string;
};

const contacts: Contact[] = [
  {
    name: "Horváth Rita",
    phoneLabel: "06/70-545-0151",
    phoneHref: "+36705450151",
    role: "Menyasszony",
  },
  {
    name: "Szkevisz Viktor",
    phoneLabel: "06/70-333-1563",
    phoneHref: "+36703331563",
    role: "Vőlegény",
  },
];

export const ContactSection = () => {
  return (
  <section id="contact" className="contact-section">
      <div className="contact-card">
        <div className="contact-header">
          <span className="contact-eyebrow">Keressetek bennünket bátran</span>
          <h2>Kapcsolat</h2>

          <p>
            Kérdés esetén az alábbi telefonszámokon tudtok elérni minket.
          </p>
        </div>

        <div className="contact-grid">
          {contacts.map((contact, index) => (
            <article className="contact-person" key={contact.phoneHref}>
              <span className="contact-number" aria-hidden="true">
                {String(index + 1).padStart(2, "0")}
              </span>

              <div
                className="contact-avatar"
                aria-hidden="true"
              >
                {contact.name
                  .split(" ")
                  .map((part) => part[0])
                  .join("")}
              </div>

              <span className="contact-role">{contact.role}</span>

              <h3>{contact.name}</h3>

              <a
                className="contact-phone"
                href={`tel:${contact.phoneHref}`}
                aria-label={`${contact.name} hívása: ${contact.phoneLabel}`}
              >
                <span className="contact-phone-icon" aria-hidden="true">
                  ☎
                </span>

                {contact.phoneLabel}
              </a>
            </article>
          ))}
        </div>

              <div className="site-signature">
        <div className="site-signature__divider">
          <span />
          <i />
          <span />
        </div>

        <p className="site-signature__text">
          Szeretettel készítette a weboldalt Rita és Viktor számára
        </p>

        <p className="site-signature__name">
          Jónás Emese
        </p>
      </div>
      </div>

    </section>
  );
};